import { memo } from 'react'

function Informations(props: InformationsProps) {
  const { title } = props

  return (
    <div className="flex flex-col flex-1 p-4 rounded-xl bg-[#839abd] xl:p-5 items-center justify-center mt-8">
      <p className="text-2xl font-bold text-white">{title}</p>
    </div>
  )
}

interface InformationsProps {
  title: string
}

export default memo(Informations)
